/* File: /src/components/ElenaAvatar.jsx */

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import avatar from '../assets/avatar_elena.png';

const ElenaAvatar = ({ loading = false, onClick = () => {}, lastMessage = "" }) => {
  const [talking, setTalking] = useState(false);

  useEffect(() => {
    if (loading) {
      setTalking(true);
    } else {
      const timeout = setTimeout(() => setTalking(false), 1000);
      return () => clearTimeout(timeout);
    }
  }, [loading]);

  return (
    <div className="relative z-50">
      {talking && lastMessage && (
        <div className="absolute bottom-24 left-28 text-white text-sm bg-black/80 px-4 py-1 rounded-md font-medium animate-fade-in max-w-[320px] shadow-lg">
          <span className="opacity-70">💬 Elena:</span> {lastMessage.slice(0, 100)}
        </div>
      )}

      <button
        onClick={onClick}
        aria-label="Elena – Chat öffnen"
        title="Elena – Chat öffnen"
        className="fixed bottom-24 left-6 z-50 w-24 h-24 focus:outline-none"
      >
        <motion.div
          className="relative w-full h-full"
          animate={talking ? { scale: [1, 1.08, 1] } : { scale: 1 }}
          transition={{ duration: 0.6, repeat: talking ? Infinity : 0 }}
        >
          <img
            src={avatar}
            alt="Elena Avatar"
            className="rounded-full w-full h-full border-4 border-emerald-400 shadow-xl"
          />
          {talking && (
            <motion.div
              className="absolute bottom-3 left-1/2 -translate-x-1/2 w-4 h-2 bg-emerald-300 rounded-full origin-center"
              animate={{ scaleY: [1, 0.5, 1], opacity: [1, 0.7, 1] }}
              transition={{ duration: 0.4, repeat: Infinity }}
            />
          )}
        </motion.div>
      </button>
    </div>
  );
};

export default ElenaAvatar;
